import React, { useState, useEffect } from 'react';
import './App.css';
import Loader from './components/Loader';
import Header from './components/Header';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Testimonial from './components/Testimonial';
import Team from './components/Team';
import Footer from './components/Footer';
import WhatsAppFloater from './components/WhatsAppFloater';

function App() {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    // Show loader for 2.5 seconds on page load
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
      {showLoader && <Loader />}
      <Header />
      <Hero />
      <Services />
      <Stats />
      <HowItWorks /> 
      <Testimonial />
      <Team />
      <Footer />
      <WhatsAppFloater />
    </div>
  );
}

export default App;
